export const geographyOptions = [
  { label: 'Australia', value: 'AUSTRALIA' },
  { label: 'Europe', value: 'EUROPE' },
];
export const thresholdHours = 48;
